import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../environments';
import {
  EchoAffirmationResult,
  EchoEncouragement,
  EchoInstance,
  EchoInvitation,
  EchoInvitationsStats,
  EchoResponse,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class EchoInstanceService {
  private httpClient = inject(HttpClient);

  currentEchoInstance: BehaviorSubject<EchoInstance | undefined> = new BehaviorSubject<
    EchoInstance | undefined
  >(undefined);

  getCurrentEchoInstance(): Observable<EchoInstance | undefined> {
    return this.currentEchoInstance;
  }

  setCurrentEchoInstance(echoInstance: EchoInstance): void {
    this.currentEchoInstance.next(echoInstance);
  }

  getEchoInstance(echoInstanceId: string): Observable<EchoInstance> {
    return this.httpClient.get<EchoInstance>(
      `${environment.apiURL}/echo-instances/${echoInstanceId}`,
    );
  }

  getEchoResponse(echoInstanceId: string): Observable<HttpResponse<EchoResponse>> {
    return this.httpClient.get<EchoResponse>(
      `${environment.apiURL}/echo-instances/${echoInstanceId}/echo-responses/me`,
      { observe: 'response' },
    );
  }

  updateEchoResponse(echoInstanceId: string, data = {}): Observable<EchoResponse> {
    return this.httpClient.put<EchoResponse>(
      `${environment.apiURL}/echo-instances/${echoInstanceId}/echo-responses/me`,
      data,
    );
  }

  getEchoInstanceGoal(echoInstanceId: string): Observable<{ goal: string }> {
    return this.httpClient.get<{ goal: string }>(
      `${environment.apiURL}/echo-instances/${echoInstanceId}/goal`,
    );
  }

  getEchoInstanceEncouragements(
    echoInstanceId: string,
  ): Observable<{ encouragements: EchoEncouragement[] }> {
    return this.httpClient.get<{
      encouragements: EchoEncouragement[];
    }>(`${environment.apiURL}/echo-instances/${echoInstanceId}/encouragements`);
  }

  getEchoInstanceResults(echoInstanceId: string): Observable<EchoAffirmationResult[]> {
    return this.httpClient.get<EchoAffirmationResult[]>(
      `${environment.apiURL}/echo-instances/${echoInstanceId}/results`,
    );
  }

  getEchoInstanceInvitations(echoInstanceId: string): Observable<EchoInvitation[]> {
    return this.httpClient.get<EchoInvitation[]>(
      `${environment.apiURL}/echo-instances/${echoInstanceId}/echo-invitations`,
    );
  }

  sendEchoInstanceInvitations(
    echoInstanceId: string,
    data: EchoInvitation[] = [],
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.apiURL}/echo-instances/${echoInstanceId}/echo-invitations`,
      data,
    );
  }

  getEchoInstanceInvitationsStats(echoInstanceId: string): Observable<EchoInvitationsStats> {
    return this.httpClient.get<EchoInvitationsStats>(
      `${environment.apiURL}/echo-instances/${echoInstanceId}/echo-invitations/stats`,
    );
  }
}
